import { UserManager, WebStorageStateStore } from "oidc-client-ts";
import UserService from "../services/user.service";
import AuthService from "../services/auth.service";

const cognitoAuthConfig = {
    authority: "https://cognito-idp.us-east-1.amazonaws.com/us-east-1_UpOdHU7ys",
    client_id: "30ua0bu4tk924p2a2al7qq7n75",
    redirect_uri: process.env.VUE_APP_COGNITO_BASE_URL + process.env.VUE_APP_COGNITO_CALLBACK_FUNCTION,
    response_type: "code",
    scope: "email openid phone",
    automaticSilentRenew: true,
    userStore: new WebStorageStateStore({ store: window.localStorage })
};

// create a UserManager instance
export const userManager = new UserManager({
    ...cognitoAuthConfig,
});

export async function signOutRedirect () {
    const clientId = "30ua0bu4tk924p2a2al7qq7n75";
    const logoutUri = process.env.VUE_APP_COGNITO_BASE_URL + "/logout/cognito/callback";
    const cognitoDomain = "https://login.gt.wratings.com/";
    window.location.href = `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(logoutUri)}`;
}
export async function isAuthenticated() {
  const user = await userManager.getUser();
  return !!(user && !user.expired);
}
export const onAuthRequiredCognito = async (from, to, next) => {
    const user = await userManager.getUser();
    let isAuthenticated = !!(user && !user.expired);
    if (from.matched.some(record => record.meta.requiresAuth) && !(isAuthenticated)) {
        signOutRedirect();
        return;
    }
    let skipValidationUrls = ['/login/cognito/callback', '/logout/cognito/callback','/login'];
    let forcedValidationUrls = ["/"];
    if (skipValidationUrls.includes(from.path)) {
      next();
      return;
    }
    if (to.meta.requiresAuth) {
      const user = await userManager.getUser();
      let loggedInUser = UserService.getUser();
      if (!user || user.expired || (typeof loggedInUser == "undefined" || AuthService.hasSessionExpired(loggedInUser))) {
        // No valid session, start login
        await userManager.signinRedirect({ state: { target: to.fullPath } });
        return; // stop navigation until after redirect
      }      
    } else if (forcedValidationUrls.includes(to.path)) {
      let forcedloggedInUser = UserService.getUser();
      if (typeof forcedloggedInUser == "undefined" || AuthService.hasSessionExpired(forcedloggedInUser)) {
        signOutRedirect();
        return;
      }          
    }
    next();
};
export default async function getAccessToken() {
  const user = await userManager.getUser();

  if (!user || user.expired) {
    return null; // Not logged in or token expired
  }

  let accessToken =  user.access_token;
  if (accessToken) {
    return { Authorization: "Bearer " + accessToken };
  }
}
